import React from "react";
import VehicleOwnerCalendar from "./VehicleOwnerCalendar";
import VehicleOwnerContingents from "./VehicleOwnerContingents";
import VehicleOwnerPrices from "./VehicleOwnerPrices";

interface Props {
    settings: any,
    setSettings: any
}

const vehicleOwner = (props: Props) => {
    const { settings, setSettings } = props;
    return (
        <>
                <form className="off-content row">
                    <VehicleOwnerCalendar
                        settings={settings}
                        setSettings={setSettings}
                        key={"vehicleOwnerCalendar"}
                    />
                    <VehicleOwnerContingents
                        settings={settings}
                        setSettings={setSettings}
                        key={"vehicleOwnerContingents"}
                    />
                    <VehicleOwnerPrices
                        settings={settings}
                        setSettings={setSettings}
                        key={"vehicleOwnerPrices"}
                    />
                </form>
        </>
    );
}

export default vehicleOwner;